export let BiFormSubmissionStatus = /*#__PURE__*/function (BiFormSubmissionStatus) {
  BiFormSubmissionStatus["INIT"] = "INITIATE_SUBMISSION";
  BiFormSubmissionStatus["VALIDATION_FAILURE"] = "VALIDATION_FAILURE";
  BiFormSubmissionStatus["FAILURE"] = "FAILURE";
  BiFormSubmissionStatus["SUCCESS"] = "SUCCESS";
  return BiFormSubmissionStatus;
}({});
//# sourceMappingURL=bi.js.map